"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'message.send.failed': 'Nie udało się wysłać wiadomości',
};
